import request from '@/utils/request'

const http = request()

export const listNotice = params => http.post('/sys/notice/list', params)

export const saveNotice = params => http.raw(params.nextStep ? '/sys/notice/submit' : '/sys/notice/save', params)

export const updateNotice = params => http.raw('/sys/notice/update', params)

export const delNotice = id => http.post('/sys/notice/delete', { id })

export const getNotice = id => http.post('/sys/notice/get', { id })

export const readNotice = id => http.post('/sys/notice/read', { id })
